import React from "react";
import Header from "./Header";
import useNowPlayingMovies from "../hooks/useNowPlayingMovies"
import MainConatiner from "./MainConatiner";
import SecondaryContainer from "./SecondaryContainer";
import DetailsMovie from "./DetailsMovie";
import usePopulorMovies from "../hooks/usePopulorMovies";
import useTopRated from "../hooks/useTopRated";
import useUpcoming from "../hooks/useUpcoming";
import { GptSearch } from "./GptSearch";
import { useSelector } from "react-redux";
import useRecomendedMovies from "../hooks/useRecomended";
import { Outlet } from "react-router-dom";
import Togglecompo from "./Togglecompo";

function Browse() {
  useNowPlayingMovies();
  usePopulorMovies();
  useTopRated();
  useUpcoming();
  // useRecomendedMovies(634492);

  const showGptSearch = useSelector((store)=>store.gpt.showGptSearch);
  const showDetails = useSelector((store)=> store.details.showDetails);
  return (
    <>
      <Header />
      {showGptSearch && !showDetails ?
      ( <GptSearch/>) : 
      (<>
        <Togglecompo/>
      </>)} 
    </>
  );
}

export default Browse;
